var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['back-to-top-btn', {'go-top': _vm.isTop}],on:{"click":function($event){return _vm.scrollToTop()}}},[_c('p',{staticClass:"top-arrow"},[_vm._v("▲")])])}
var staticRenderFns = []

export { render, staticRenderFns }